import script from "./AvatarUser.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarUser.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__